module.exports = __webpack_public_path__ + "../resources/img/ic_incomplete_number_1.ba553ac5.svg";